module.exports = __webpack_public_path__ + "img/testimonials-4.a159dd6f.jpg";